import React from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY || '')

export const StripePaymentProvider: React.FC = ({ children }) => {
  return <Elements stripe={stripePromise}>{children}</Elements>
}
